export default __webpack_public_path__ + "static/media/rocket.29daee2f.png";